import { GetCampaignFn, initGetCampaignFn } from './methods/get-campaign';
import { GetOffersFn, initGetOffersFn } from './methods/get-offers';
import { GetPropertiesFn, initGetPropertiesFn } from './methods/get-properties';
import { ContentfulSettings } from './types';
import { GetPackagesFn, initGetPackagesFn } from './methods/get-packages';
import { GetEntryByIdFn, initGetEntryByIdFn } from './methods/get-entry-by-id';

export interface IContentfulSdk {
    getCampaign: GetCampaignFn;
    getProperties: GetPropertiesFn;
    getOffers: GetOffersFn;
    getPackages: GetPackagesFn;
    getEntryById: GetEntryByIdFn;
}

export class ContentfulSdk implements IContentfulSdk {
    getCampaign: GetCampaignFn;
    getProperties: GetPropertiesFn;
    getOffers: GetOffersFn;
    getPackages: GetPackagesFn;
    getEntryById: GetEntryByIdFn;

    constructor({
        accessToken,
        baseUrl,
        environmentId,
        spaceId,
    }: {
        accessToken: string;
        baseUrl: string;
        environmentId: string;
        spaceId: string;
    }) {
        const contentfulSettings: ContentfulSettings = {
            accessToken,
            baseUrl: `${baseUrl}/spaces/${spaceId}/environments/${environmentId}`,
        };
        this.getCampaign = initGetCampaignFn(contentfulSettings);
        this.getOffers = initGetOffersFn(contentfulSettings);
        this.getProperties = initGetPropertiesFn(contentfulSettings);
        this.getPackages = initGetPackagesFn(contentfulSettings);
        this.getEntryById = initGetEntryByIdFn(contentfulSettings);
    }
}
